export const companyLimit = 20;
